import React from "react";
import { Color } from "../../../../Utils/styles";
import {
  cutText,
  renderCost,
  renderImage,
  renderAltImage,
  renderCategoryRoute,
  sepMoney,
} from "../../../Common/Function";
import { AiOutlineTag } from "react-icons/ai";
import { MdLocationPin } from "react-icons/md";
import { RiPriceTag2Line } from "react-icons/ri";
import { useReserve } from "../Hooks";
import { Link } from "react-router-dom";

function Card({ data, isOff = false, single = false }) {
  const { navigate } = useReserve();
  const renderOffer = () => {
    if (data.off) {
      return (
        <div
          style={{
            display: "flex",
            // flexDirection: "column",
            alignItems: "center",
            position: "absolute",
            backgroundColor: Color.white,
            top: "24px",
            borderBottomLeftRadius: "5px",
            // width: "100px",
            // transform: "rotate(45deg)",
            // right: "10px",
            justifyContent: "center",
            backgroundColor: "rgb(101, 203, 119)",
            right: isOff ? 0 : "none",
          }}
        >
          <div style={{}}>
            <h6
              style={{
                color: Color.white,
                fontSize: "12px",
                fontWeight: "400",
                padding: "2px 8px",
              }}
            >{`تخفیف رزرو  ${data.category.name} تا`}</h6>
          </div>
          <div
            style={{
              backgroundColor: "rgb(57, 175, 98)",
              padding: "3px 8px",
            }}
          >
            <h6
              style={{
                color: Color.white,
                fontSize: "12px",
                fontWeight: "400",
              }}
            >{`٪${Math.ceil(data.off.offpersentage)}`}</h6>
          </div>
          {/* <span
            style={{ color: Color.white, fontSize: "12px", fontWeight: "400" }}
          >{``}</span>
          <span className="" style={{ margin: "0 2px" }}></span>
          <span
            style={{ color: Color.white, fontSize: "10px", fontWeight: "300" }}
          >
            تخفیف
          </span> */}
        </div>
      );
    }
  };
  const renderOff = () => {
    if (data.off) {
      return {
        badge: () => {
          return (
            <span
              style={{
                color: Color.white,
                fontSize: "13px",
                fontWeight: "400",
                backgroundColor: "#028A1A",
                borderRadius: 5,
                padding: "3px 10px",
              }}
            >{`٪${Math.ceil(data.off.offpersentage)}`}</span>
          );
        },
        price: () => {
          return (
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ flex: 1 }}
            >
              <p style={{ fontWeight: "400" }}>شروع قیمت از</p>
              <span style={{ fontWeight: "500", color: Color.primary }}>
                {renderCost({ header_price: data.off.second_price })}
              </span>
            </div>
          );
        },
      };
    }
    return {
      badge: () => { },
      price: () => { },
    };
  };

  return (
    <div className="off-card border" dir="rtl" style={{ cursor: "pointer", maxWidth: "320px" }}>
      <div className="off-img" onClick={e => navigate(single
        ? `${renderCategoryRoute(data.category.id).route}/${data.city && data.city[0].slug
        }/${data.slug}`
        : `${data.city && data.city[0].slug}/${data.slug}`)}>
          
        <img src={renderImage(data)} style={{}} alt={renderAltImage(data)} />
        {renderOffer()}
      </div>
      <div
        style={{
          margin: isOff ? "10px" : "0",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Link className="linkAllel" to={
          single
            ? `${renderCategoryRoute(data.category.id).route}/${data.city && data.city[0].slug
            }/${data.slug}`
            : `${data.city && data.city[0].slug}/${data.slug}`
        }>
          <div
            style={{
              padding: !isOff ? "10px" : "0",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <h4
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                  }}
                >
                  {cutText(data.name, 27)}
                </h4>
              </div>
              <div className="d-flex justify-content-end align-items-center">
                <h6 style={{ padding: "0", margin: "0", fontWeight: "400" }}>
                  {Math.ceil(data.comments_avg_score) || 5}
                </h6>

                <img
                  src={window.origin + "/WebSide/assets/images/star.png"}
                  alt="امتیاز"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginLeft: "5px",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: "15px",
              }}
            >
              <MdLocationPin size={"1.5rem"} />
              <p
                className="address "
                style={{
                  fontWeight: "400",
                  // color: Color.textSecondry,
                }}
              >
                {cutText(data.address, window.innerWidth < 1200 ? 25 : 32)}
              </p>
            </div>
            <div
              style={{
                height: "25.5px",
              }}
              className="d-flex align-items-center mt-1 justify-content-between"
            >
              <p
                style={{
                  fontSize: "9px",
                  lineHeight: "15px",
                  fontWeight: "400",
                }}
              >
                <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                  <AiOutlineTag size={"1.5rem"} />
                </span>
                {data &&
                  data.tags &&
                  data.tags.map((tag, id) => {
                    if (id < 4)
                      return `${tag.name}${data.tags.length > 4
                        ? id < 3
                          ? " , "
                          : ""
                        : data.tags.length == 1
                          ? ""
                          : id != data.tags.length - 1
                            ? ","
                            : ""
                        } `;
                  })}
              </p>
              {renderOff().badge()}
            </div>
          </div>

          {isOff ? (
            <Link
              style={{ display: "block", color: Color.black }}
              to={`${data.city && data.city[0].slug}/${data.slug}`}
            >
              <hr style={{ margin: "10px 0" }} />
              <div style={{ display: "flex" }}>{renderOff().price()}</div>{" "}
            </Link>
          ) : (
            <Link
              style={{ display: "flex", justifyContent: "center" }}
              to={
                single
                  ? `${renderCategoryRoute(data.category.id).route}/${data.city && data.city[0].slug
                  }/${data.slug}`
                  : `${data.city && data.city[0].slug}/${data.slug}`
              }
              className="off-btn"
            >
              شروع قیمت از {sepMoney(data.header_price)} هزارتومان
            </Link>
          )}
        </Link>
      </div>
    </div >
  );
}

export default Card;
